// extracted by mini-css-extract-plugin
export default {"container":"error_container__B4tTb","appear":"error_appear__N-ZM7","rotate":"error_rotate__NJakw"};